/**
 * @module app.config.apiservice
 */
class ApiService {
  /**
   * @param {!angular.$http} $http
   * @param {string} apiUrl
   * @param {app.AuthenticationService} appAuthenticationService
   * @ngInject
   */
  constructor($http, apiUrl, appAuthenticationService) {
    /**
     * @private
     */
    this.http_ = $http;

    /**
     * @private
     */
    this.apiUrl_ = apiUrl;

    /**
     * @private
     */
    this.authentication_ = appAuthenticationService;
  }

  /**
   * @return {!angular.$q.Promise<appx.UserSettings>}
   */
  getUserSettings() {
    return this.http_.get(`${this.apiUrl_}4/usersettings`).then((response) => {
      return response.data;
    }).catch(err => {
      if (err.status === 401) {
        this.authentication_.delog();
      }
    });
  }

  /**
   * @param {!appx.UserSettings} userSettings
   * @return {!angular.$q.Promise}
   */
  putUserSettings(userSettings) {
    return this.http_.put(`${this.apiUrl_}4/usersettings`, userSettings);
  }
}

export default angular.module('appConfigApiService', []).service('appConfigApiService', ApiService);
